import React, { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useModal } from "../../context/ModalContext";

const SignUpToReview = () => {
  const { setCurrentModal } = useModal();
  const navigate = useNavigate();
  return (
    <div
      className="signin-container"
      style={{
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <a href="/" style={{ cursor: "pointer" }}>
        <img src="/images/fullproof_logo_black.svg" alt="Fullproof" style={{ height: "47px", marginBottom: 10 }} />
      </a>
      <div style={{ height: 40 }} />
      <img src="/images/reviews.png" alt="Fullproof" style={{ width: "40%", marginBottom: 10 }} />
      <div style={{ fontSize: "1rem", padding: "10px 0 20px 0", fontWeight: 500 }}>
        Just sign in to write a review! Please note that only people with verified purchases of a product can submit a rating.
      </div>
      <div
        onClick={() => setCurrentModal("signUp")}
        style={{
          fontSize: "1.1rem",
          fontWeight: 600,
          background: "black",
          width: "100%",
          textAlign: "center",
          padding: 8,
          borderRadius: 50,
          color: "white",
          cursor: "pointer",
        }}
      >
        Sign Up
      </div>
      <div style={{ padding: 10 }}>or</div>
      <div
        onClick={() => setCurrentModal("signIn")}
        style={{
          fontSize: "1.1rem",
          fontWeight: 600,
          border: "1px solid black",
          width: "100%",
          textAlign: "center",
          padding: 8,
          borderRadius: 50,
          color: "black",
          cursor: "pointer",
        }}
      >
        Sign In
      </div>
    </div>
  );
};

export default SignUpToReview;
